import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { DatePipe } from '@angular/common';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CalendarFilter } from '../models/CalendarFilter';
import { Student, Vacation, VacationFile, VacationRow } from '../models/CalendarModels';
import { AccountScheduleMain, BaseClassSchedule, CalendarRequest, ClassScheduleRequest, ClassVacationRequest, StudentScheduleRequest, StudentVacationRequest, VacationRequest } from '../models/CalendarRequest';
import { AdvancedOptionSet, OptionSet } from '../models/OptionSet';
import { ScheduleRow } from '../models/ScheduleRow';
import { GeneralSchedule, Schedule_ep } from '../models/Schedule_ep';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  public rout = "CalendarActions";
  request: CalendarRequest;

  public ClassesList: Array<OptionSet> = new Array<OptionSet>();
  public ClassCodesList: Array<OptionSet> = new Array<OptionSet>();
  public ClassificationList: Array<OptionSet> = new Array<OptionSet>();
  public CampList: Array<OptionSet> = new Array<OptionSet>();
  public ScheduleHoursList: Array<OptionSet> = new Array<OptionSet>();
  public ScheduleTypeList: Array<OptionSet> = new Array<OptionSet>();
  public PeriodDescriptionList: Array<OptionSet> = new Array<OptionSet>();
  public ColorsList: Array<AdvancedOptionSet> = new Array<AdvancedOptionSet>();
  public accountSchedule: Schedule_ep;
  public noonAccountSchedule: Schedule_ep;
  public vacations: Vacation[] = [];
  public classVacsationsList: Vacation[] = [];
  public classVacationsListFiltered: Vacation[] = [];
  public studentsList: Student[] = [];
  public studentsListFiltered: Student[] = [];
  public classSchedulesList: Schedule_ep[] = [];
  public classSchedulesListFiltered: Schedule_ep[] = [];

  public studentsCountObject = {};
  public accountScheduleSubject = new Subject<object>();
  public filterSubject = new Subject<CalendarFilter>();
  public wideFilterSubject = new Subject<ScheduleRow[]>();
  public filterStudentsSubject = new Subject<ScheduleRow[]>();
  public classScheduleSubject = new Subject<object>();
  public classVacationSubject = new Subject<object>();
  public studentsSubject = new Subject<object>();
  public spinnerSubject = new Subject<object>();
  public calendarChosen = new Subject<ScheduleRow[]>();

  public vacationChosen = new Subject<VacationRow[]>();

  public dataFilter: CalendarFilter = new CalendarFilter();
  public loading: boolean = true;
  isNoonMode: boolean = false;
  public selectedCamp: OptionSet;
  // IsFilterbYCamp :boolean = false;
  public IsFilterbYCamp = new EventEmitter<boolean>();

  constructor(public dataService: DataService, public datePipe: DatePipe) {
    this.request = new CalendarRequest();
  }

  getModalOptions() {
    this.request.Action = "GetModalOptions";
    return this.dataService.setRequstData(this.rout, this.request).then((res: any) => {
      if (!this.dataService.IsError(res)) {
        var Data = JSON.parse(res);
        this.ClassesList = Data.ClassesList;
        this.ClassCodesList = Data.ClassCodesList;
        this.ClassificationList = Data.ClassificationList;
        this.CampList = Data.CampList;
        this.ScheduleHoursList = Data.ScheduleHoursList;
        this.ScheduleTypeList = Data.ScheduleTypeList;
        this.PeriodDescriptionList = Data.PeriodDescriptionList;
        //this.ColorsList = Data.ColorsList.map(x => {
        //  return { value: x.value, viewValue: x.viewValue, viewValueEn: this.setColorName(x.viewValue), };
        //});
        if (this.accountSchedule) {
          this.accountScheduleSubject.next();
        }
      }
    }).catch(error => {
      debugger
    });
  }
  setColorName(viewValue: string) {
    switch (viewValue) {
      case 'אדום':
        return 'red';
      case 'ירוק':
        return 'green';
      case 'כחול':
        return 'blue';
      case 'כתום':
        return 'orange';
      case 'ורוד':
        return 'pink';
      default:
        return null;
    }
  }

  loadSchedulesAndVacationLists() {
    this.getStudents();//רשימת תלמידים
    this.getMainAccountSchedule();//מערכת שעות כללית למוסד
    //this.getVacationsForAccount();//חופשות למוסד - נשלפות בהתאם לחודש המבוקש
    this.getSchedulesForClasses();//מערכת שעות לכיתות
    this.getVacationsForClasses();//חופשות  לכיתות
  }

  getMainAccountSchedule() {
    this.request.Action = "GetMainAccountSchedule";
    console.log("GetMainAccountSchedule1")
    this.dataService.setRequstData(this.rout, this.request).then((res: any) => {
      const allGeneralSchedules: GeneralSchedule = JSON.parse(res);
      this.accountSchedule = allGeneralSchedules.mainSchedule;
      this.noonAccountSchedule = allGeneralSchedules.Tzaharon;
      if (this.ScheduleHoursList.length > 0) {
        this.accountScheduleSubject.next();
      }
    });
  }

  saveAccountSchedule(schedule: Schedule_ep) {

    this.request.Action = "SaveAccountSchedule";
    this.request.accountSchedule = schedule;
    return this.dataService.setRequstData(this.rout, this.request);
  }

  getVacationsForAccount(date) {
    this.request.Action = "GetVacationsForAccount";
    this.request.MonthForVacationsOfAccount = date;
    return this.dataService.setRequstData(this.rout, this.request);
  }

  getOption(value: string, options: any) {

    return value != null ? options.filter(m => { return m.value == value })[0] : null;
  }

  saveVacationForAccountWithFiles(vacation: VacationRequest, newFiles: VacationFile[], existingFiles: VacationFile[]) {
    const formData = new FormData();

    formData.append("Action", "SaveVacationForAccount");
    formData.append("VacationRequest", JSON.stringify(vacation));

    newFiles.forEach((item, index) => {
      formData.append(`newFiles[${index}]`, item.File, item.FileName);
      formData.append(`newNotes[${index}]`, item.Note || '');
    });

    existingFiles.forEach((item, index) => {
      formData.append(`existingFileIds[${index}]`, item.FileId);
      formData.append(`existingNotes[${index}]`, item.Note || '');
    });

    return this.dataService.sendFormData("CalendarActionsWithFiles", formData);
  }

  saveStudentSchedule(request: StudentScheduleRequest) {
    this.request.Action = "SaveStudentSpecificSchedule";
    this.request.StudentScheduleRequest = request;
    return this.dataService.setRequstData(this.rout, this.request);
  }

  changeSchduleStatusToCancelWait(request: ClassScheduleRequest) {
    this.request.Action = "ChangeSchduleStatusToCancelWait";
    this.request.ClassScheduleRequest = request;
    return this.dataService.setRequstData(this.rout, this.request);
  }

  changeVacationStatusToCancelWait(request: ClassVacationRequest) {
    this.request.Action = "ChangeVacationStatusToCancelWait";
    this.request.ClassVacationRequest = request;
    return this.dataService.setRequstData(this.rout, this.request);
  }

  saveClassSchedule(request: ClassScheduleRequest) {
    this.request.Action = "SaveClassSchedule";
    this.request.ClassScheduleRequest = request;
    return this.dataService.setRequstData(this.rout, this.request);
  }

  downloadVacationFile(fileId: string): Promise<Blob> {
    const request: any = {
      Action: "DownloadVacationFile",
      DownloadFileRequest: { fileId: fileId }
    };

    return this.dataService.setRequstDataForBlob(this.rout, request);
  }

  getStudents() {
    console.log("GetStudents")

    this.request.Action = "GetStudents";
    this.dataService.setRequstData(this.rout, this.request).then((res: any) => {
      this.studentsList = JSON.parse(res);
      this.studentsSubject.next();
    });
  }

  getSchedulesForClasses() {
    console.log("GetSchedulesForClasses")

    this.request.Action = "GetSchedulesForClasses";
    this.spinnerSubjectEmit(true);
    this.dataService.setRequstData(this.rout, this.request).then((res: any) => {
      this.classSchedulesList = JSON.parse(res);
      //if (this.classSchedulesList.length > 0) {
      this.classScheduleSubject.next();
    }//
    );
  }

  getVacationsForClasses() {
    console.log("GetVacationsForClasses")
    this.request.Action = "GetVacationsForClasses";
    this.dataService.setRequstData(this.rout, this.request).then((res: any) => {
      if (!this.dataService.IsError(res)) {
        this.classVacsationsList = JSON.parse(res);
        this.classVacsationsList.forEach(x => {
          x.Dates = this.getDatesBetweenTwoDates(new Date(x.Date), new Date(x.DateTo));
        });
        this.classVacationSubject.next();
        this.wideFilterSubject.next([]);
      }
    }
    );
  }

  getAuthorityStatuses(ItemId: any, entityName: string) {
    this.request.Action = "GetAuthorityStatuses";
    this.request.AuthorityStatusesRequest = { ItemId: ItemId, FilterName: entityName };
    return this.dataService.setRequstData(this.rout, this.request);
  }

  saveStudentVacationWithFiles(studentVacationRequest: StudentVacationRequest, newFiles: VacationFile[], existingFiles: VacationFile[]) {
    const formData = new FormData();

    formData.append("Action", "SaveGeneralVacationForStudents");
    formData.append("StudentVacationRequest", JSON.stringify(studentVacationRequest));

    newFiles.forEach((item, index) => {
      formData.append(`newFiles[${index}]`, item.File, item.FileName);
      formData.append(`newNotes[${index}]`, item.Note || '');
    });
    existingFiles.forEach((item, index) => {
      formData.append(`existingFileIds[${index}]`, item.FileId);
      formData.append(`existingNotes[${index}]`, item.Note || '');
    });

    return this.dataService.sendFormData("CalendarActionsWithFiles", formData);
  }

  saveClassVacationWithFiles(classVacationRequest: ClassVacationRequest, newFiles: VacationFile[], existingFiles: VacationFile[]) {
    const formData = new FormData();

    formData.append("Action", "SaveClassVacation");
    formData.append("ClassVacationRequest", JSON.stringify(classVacationRequest));

    newFiles.forEach((item, index) => {
      formData.append(`newFiles[${index}]`, item.File, item.FileName);
      formData.append(`newNotes[${index}]`, item.Note || '');
    });
    existingFiles.forEach((item, index) => {
      formData.append(`existingFileIds[${index}]`, item.FileId);
      formData.append(`existingNotes[${index}]`, item.Note || '');
    });

    return this.dataService.sendFormData("CalendarActionsWithFiles", formData);
  }


  transformDate(date, format) {
    return this.datePipe.transform(date, format)
  }

  filterCalendar(filterData: CalendarFilter) {
    this.dataFilter = filterData;
    this.filterSubject.next(filterData);
  }

  filterCalendarWidely(scdls: any[]) {
    this.wideFilterSubject.next(scdls);
  }
  filterStudentsWidely(scdls: any[]) {
    this.filterStudentsSubject.next(scdls);
  }

  countStudents(classesSchudeule: Schedule_ep[], students: Student[]) {
    for (let scdl of classesSchudeule) {//O(m)
      scdl.studentCount = 0;
      if (this.studentsCountObject[scdl.Class.value + ""]) {
        this.studentsCountObject[scdl.Class.value][scdl.ClassCode ? scdl.ClassCode.value : 0] = scdl;
      }
      else {
        this.studentsCountObject[scdl.Class.value + ""] = [{ studentCount: 0 }];
        this.studentsCountObject[scdl.Class.value + ""][scdl.ClassCode ? scdl.ClassCode.value : 0] = scdl;
      }
    }

    for (let stdnt of students) {//O(n)
      if (this.studentsCountObject[stdnt.Class.value])
        if (this.studentsCountObject[stdnt.Class.value][stdnt.ClassCode ? stdnt.ClassCode.value : 0]) {
          this.studentsCountObject[stdnt.Class.value][stdnt.ClassCode ? stdnt.ClassCode.value : 0]["studentCount"] += 1;
        }
        else {
          this.studentsCountObject[stdnt.Class.value][0]["studentCount"] += 1;
        }
    }
  }


  studentScheduleSelected = new Subject<Schedule_ep>();
  studentSelected = new Subject<any>();
  GetStudentSpecificSchedule() {
    this.request.Action = "GetStudentSpecificSchedule";
    return this.dataService.setRequstData(this.rout, this.request);
  }
  fillStudentSchedule(scdl: any) {
    if (scdl && Object.keys(scdl).length > 0) {
      this.studentScheduleSelected.next(scdl);
    }
    else {
      this.studentScheduleSelected.next(null);
    }
    // if (scdl == null) {
    //   this.studentScheduleSelected.next(this.accountSchedule)
    // }
    // else {
    //   if (Object.keys(scdl).length === 0) {
    //     this.studentScheduleSelected.next(null);
    //   }
    //   else
    //     this.studentScheduleSelected.next(scdl);
    // }
  }
  spinnerSubjectEmit(loading) {
    this.spinnerSubject.next(loading)
  }

  getDatesBetweenTwoDates(startDate, endDate) {
    const dates = []
    let currentDate = startDate
    const addDays = function (days) {
      const date = new Date(this.valueOf())
      date.setDate(date.getDate() + days)
      return date
    }
    while (currentDate <= endDate) {
      dates.push(this.transformDate(currentDate, "yyyy-MM-dd"));
      currentDate = addDays.call(currentDate, 1)
    }
    return dates
  }

  mapStudentsFromStringToObject(Students: string[]): Student[] {
    let res = Students.map(x => {
      return this.studentsList.find(s => s.Id == x)
    });
    return res;
  }

  addClassSchedule(classScheduleData: BaseClassSchedule) {
    this.request.Action = "AddClassSchedule";
    this.request.BaseClassSchedule = classScheduleData;
    return this.dataService.setRequstData(this.rout, this.request);
  }

}
